module.exports = __webpack_public_path__ + "static/accruent.0a1970e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commercial_logos/accruent.png
// module id = 2167
// module chunks = 61762850755587